import { render, staticRenderFns } from "./EmployeeLeavesEditDetails.vue?vue&type=template&id=54eeae92"
import script from "./EmployeeLeavesEditDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeLeavesEditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports